<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :placeholder="placeholder"
    solo
    flat
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
    :disabled="disabled"
  />
</template>

<script>
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    intervel: {
      type: Number,
      default: 60,
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      /*  this.time = null; */
      this.emitValue();
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      this.time = this.value;
      this.ensureValueInList();
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    ensureValueInList() {
      if (!this.time) return;
      if (!Array.isArray(this.timeList)) return;
      if (this.timeList.some((item) => item.value === this.time)) return;

      const referenceDate = moment().format("YYYY-MM-DD");
      const currentValue = moment(
        `${referenceDate} ${this.time}`,
        "YYYY-MM-DD hh:mm A"
      );
      if (!currentValue.isValid()) return;

      const minTime = this.minTime
        ? moment(`${referenceDate} ${this.minTime}`, "YYYY-MM-DD hh:mm A")
        : null;

      const disabled = !!(minTime && currentValue.isBefore(minTime));

      let index = this.timeList.findIndex((item) => {
        const itemValue = moment(
          `${referenceDate} ${item.value}`,
          "YYYY-MM-DD hh:mm A"
        );
        return itemValue.isValid() && itemValue.isAfter(currentValue);
      });
      if (index === -1) {
        index = this.timeList.length;
      }

      this.timeList.splice(index, 0, {
        text: this.time,
        value: this.time,
        disabled,
      });
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime = this.minTime
        ? moment(`${moment().format("YYYY-MM-DD")} ${this.minTime}`)
        : null;
      let value = startTime.format("hh:mm A");
      while (startTime.isBefore(endTime)) {
        if (startTime && startTime.isBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
        value = startTime.add(this.intervel, "minutes").format("hh:mm A");
      }
      this.ensureValueInList();
    },
    /* initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime = this.minTime
        ? moment(`${moment().format("YYYY-MM-DD")} ${this.minTime}`)
        : null;
      while (startTime.isBefore(endTime)) {

        let value = startTime.add(30, "minutes").format("hh:mm A");
        if (startTime && startTime.isBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
      }
    }, */
  },
  mounted() {
    this.init();
    this.initTimeList();
  },
};
</script>
